module.exports = __webpack_public_path__ + "media/common/images/badges/active/nakrmeny_mozek-d6720ee8dfa59a5de8d56fb3fa017293.svg";